export enum ChangeType {
  Paths = 'paths',
  Name = 'name',
  Triggers = 'triggers',
  Conditions = 'conditions',
}
